<template>
  <div class="site-shell">
    <headerNav></headerNav>
    <main class="site-main">
      <NuxtPage />
    </main>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.site-main {
  /* The header is 163px + 50px in the 1920px design, scaled by PostCSS.
     Reserve the first viewport while an async route/category is loading. */
  min-height: calc(100vh - 213px);
  display: flow-root;
}
</style>

<style>
/* Apply the page origin before lazy route styles and the component library load. */
body {
  margin: 0;
}

/* Catalog cards own their bottom spacing. Keep other routes' viewport reserve. */
.site-main:has(> .product-category-page[data-catalog-layout="pending"]),
.site-main:has(> .product-category-page[data-catalog-layout="grid"]),
.site-main:has(> .product-category-page[data-catalog-layout="error"]) {
  min-height: 0;
}

/* Present the footer after the current catalog request chain has settled.
   Its geometry remains in normal flow; the catalog itself stays visible. */
.site-main:has(> .product-category-page[data-catalog-layout="pending"]) + .footer {
  visibility: hidden;
}
</style>
